function toggleMenu() {
    const body = document.body;
    const html = document.documentElement;

    const menuIsOpen = body.classList.contains('mobilemenu-open');

    if (menuIsOpen) {
        body.classList.remove('mobilemenu-open');
        html.classList.remove('noscroll');

    } else {
        body.classList.add('mobilemenu-open');
        html.classList.add('noscroll');
    }

    return false;
}

function closeMenuOnLargeScreens() {
    if (window.innerWidth > 768) {
        document.body.classList.remove('mobilemenu-open');
        document.documentElement.classList.remove('noscroll');
    }
}

function setMobilemenuClickable() {
    const menuItems = document.querySelectorAll('ul.main-menu > li');

    menuItems.forEach(function (li) {
        const menuItemWithChildren = li.querySelector('a.menu-item-has-children');

        if (menuItemWithChildren) {
            menuItemWithChildren.addEventListener('click', function (event) {
                event.preventDefault();

                const submenu = li.querySelector('.sub-menu');
                if (submenu) {
                    submenu.classList.toggle('open');
                }
            });
        }
    });
}

function setDesktopHoverable() {
    const menuItems = document.querySelectorAll('ul.main-menu > li');

    function isDesktop() {
        return window.innerWidth >= 1024;
    }

    menuItems.forEach(function (li) {
        const submenu = li.querySelector('.sub-menu');
        if (!submenu) return;

        li.addEventListener('mouseenter', function () {
            if (isDesktop()) {
                submenu.classList.add('open');
                // Trigger reflow to enable transition
                void submenu.offsetWidth;
                submenu.classList.add('active');
            }
        });

        li.addEventListener('mouseleave', function () {
            if (isDesktop()) {
                submenu.classList.remove('active');
                // Wait for transition to finish before removing open
                setTimeout(() => {
                    if (!submenu.classList.contains('active')) {
                        submenu.classList.remove('open');
                    }
                }, 300);
            }
        });
    });
}

function initStickyHeader() {
    const header = document.querySelector('header.sticky');
    if (!header) return;

    const SCROLL_THRESHOLD = 50;

    function updateStuckState() {
        if (window.scrollY > SCROLL_THRESHOLD) {
            header.classList.add('is-stuck');
        } else {
            header.classList.remove('is-stuck');
        }
    }

    window.addEventListener('scroll', updateStuckState, { passive: true });
    updateStuckState();
}

window.addEventListener('DOMContentLoaded', () => {
    const menuToggle = document.querySelector('.js__openmenu');
    if (menuToggle) {
        menuToggle.addEventListener('click', (event) => {
            event.preventDefault();
            toggleMenu();
        });
    }

    initStickyHeader();
    setMobilemenuClickable();
    setDesktopHoverable();

    // Schließe Submenus, wenn außerhalb geklickt wird
    document.addEventListener('click', function (event) {
        const openSubmenus = document.querySelectorAll('.sub-menu.open');
        openSubmenus.forEach(function (submenu) {
            // Prüfen, ob der Klick innerhalb des Submenus oder des zugehörigen Menü-Items war
            if (!submenu.contains(event.target) && !submenu.parentElement.contains(event.target)) {
                submenu.classList.remove('active', 'open');
            }
        });
    });

    window.addEventListener('resize', function () {
        closeMenuOnLargeScreens();
        if (window.innerWidth >= 1024) {
            document.querySelectorAll('.sub-menu.open').forEach(function (submenu) {
                submenu.classList.remove('active', 'open');
            });
        }
    });
});